import src from "./gq.svg";
export default { src: src, aspect: 1.8484848484848484, width: 61, height: 33 };